/* eslint-disable @typescript-eslint/naming-convention */
export interface DropdownEmployeeDetailDto {
  Name: string;
  Id: string;
  FullName: string;
  FirstName: string;
  LastName: string;
  MiddleName: string;
  Suffix: string;
  SSN: string;
  Last4SSN: string;
  BirthDate: Date | null;
  SSNSecured: string;
  CellPhone: string;
  EMDesignationName: string;
  FileClassName: string;
  Craft: string;
  FilePayRate: number | null;
  Email: string;
  HRRef: number | null;
  Company: number | null;
  CompanyID: string | null;
  VPPRId: string;
  PRGroup: number | null;
  PRDept: string | null;
  IsActive: boolean;
  RehireStatus: string | null;
  IsUserFavorite?: boolean;
}
